<app-modal-filler-atom [index]="5"></app-modal-filler-atom>
<div
  class="fixed inset-0 left-0 top-0 h-screen w-screen"
  [style.z-index]="((index$ | async) ?? 0) + 55"
>
  @if (this.content()?.(); as contentData) {
    <ng-container *ngTemplateOutlet="contentData"></ng-container>
  }
  @if (this.componentRef()?.(); as componentRefData) {
    <ng-container *ngComponentOutlet="componentRefData"></ng-container>
  }
</div>
